import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/reset.css';
import './assets/CSS/main.css';
import request from './utils/request'; // 引入 Axios 实例

import echarts from "echarts";

Vue.use(ElementUI);

Vue.config.productionTip = false
// 将 Axios 实例挂载到 Vue 原型上
Vue.prototype.$axios = request;
Vue.prototype.$echarts = echarts;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
